<div class="mt-4 flex flex-col gap-4 md:flex-row">
  @if (hasEditPermission) {
    <div class="w-full md:w-1/2">
      <p class="font-semibold" data-test-id="select-icd-codes-title">Select up to 4 ICD codes:</p>
      <div class="pt-4">
        <p-listbox
          [options]="availableIcds"
          [listStyle]="{ 'height': '18rem' }"
          [readonly]="!canAddIcds"
          (onClick)="selectIcd($event)"
          data-test-id="select-icd-codes-listbox"
        ></p-listbox>
      </div>
    </div>
  }

  <div [class]="hasEditPermission ? 'w-full md:w-1/2 md:pl-4' : 'w-full'">
    @if (hasEditPermission) {
      <span class="font-semibold" data-test-id="re-assign-icd-codes-title">
        Click the up or down buttons to re-assign Primary, Secondary, Tertiary, and Quaternary codes:
      </span>
    } @else {
      <span class="font-semibold">Primary, Secondary, Tertiary and Quaternary Codes:</span>
    }
    <div class="pt-4">
      <p-listbox
        [options]="newSelectedIcds"
        [listStyle]="{ 'height': '18rem' }"
        class="listbox-item-selectable-text"
        data-test-id="re-assign-icd-codes-listbox"
      >
        <ng-template let-icd let-i="index" pTemplate="item">
          <div class="diagnosis-list-item">
            <div data-test-id="diagnosis-list-item-value">({{orderTypeList[i]}}) {{ icd.label }}</div>
            @if (hasEditPermission) {
              <div class="diagnosis-list-buttons">
                <button
                  pButton
                  type="button"
                  class="p-button-sm mr-2"
                  icon="pi pi-chevron-up"
                  iconPos="left"
                  [disabled]="i === 0 || isInterruption"
                  (click)="moveSelectedIcd(icd.value, true)"
                  data-test-id="move-icd-up-button"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-sm mr-2"
                  icon="pi pi-chevron-down"
                  iconPos="left"
                  [disabled]="newSelectedIcds.length - 1 === i || isInterruption"
                  (click)="moveSelectedIcd(icd.value, false)"
                  data-test-id="move-icd-down-button"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-times"
                  iconPos="left"
                  [disabled]="isInterruption"
                  (click)="removeIcd(icd)"
                  data-test-id="remove-icd-button"
                ></button>
              </div>
            }
          </div>
        </ng-template>
      </p-listbox>
    </div>
  </div>
</div>
